"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Img = require("./Img");

var _PTTLayout = require("./PTTLayout");

var _excluded = ["photoUrl", "fallbackPhotoUrl", "productName", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Renders the image at photoUrl, or the image at fallbackPhotoUrl if photoUrl is not available, or a fallback icon if neither is available.
 * This allows to render a variant photo OR the main product photo OR a fallback icon.
 */
var ProductImage = function ProductImage(_ref) {
  var _ref$photoUrl = _ref.photoUrl,
      photoUrl = _ref$photoUrl === void 0 ? '' : _ref$photoUrl,
      fallbackPhotoUrl = _ref.fallbackPhotoUrl,
      productName = _ref.productName,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var fallback = /*#__PURE__*/_react["default"].createElement(FallbackContainer, _extends({
    className: className
  }, rest), /*#__PURE__*/_react["default"].createElement(FallbackIcon, null));

  return /*#__PURE__*/_react["default"].createElement(Image, _extends({
    src: photoUrl,
    alt: "Photo of product ".concat(productName),
    className: className,
    fallback: fallbackPhotoUrl ? /*#__PURE__*/_react["default"].createElement(Image, _extends({
      src: fallbackPhotoUrl,
      alt: "Photo of product ".concat(productName),
      className: className,
      fallback: fallback
    }, rest)) : fallback
  }, rest));
};

exports.ProductImage = ProductImage;
var Image = (0, _styledComponents["default"])(_Img.Img).withConfig({
  displayName: "ProductImage__Image",
  componentId: "sc-z3xy5h-0"
})(["border-radius:3px;object-fit:contain;overflow:hidden;aspect-ratio:1/1;background:white;", ""], _PTTLayout.Layout);

var FallbackIcon = _styledComponents["default"].i.attrs({
  className: 'fa-light fa-shirt'
}).withConfig({
  displayName: "ProductImage__FallbackIcon",
  componentId: "sc-z3xy5h-1"
})(["color:var(--blox-slate1b);font-size:20px;"]);

var FallbackContainer = _styledComponents["default"].div.withConfig({
  displayName: "ProductImage__FallbackContainer",
  componentId: "sc-z3xy5h-2"
})(["border-radius:3px;background-color:var(--blox-slate1);display:flex;justify-content:center;align-items:center;aspect-ratio:1/1;", ""], _PTTLayout.Layout);